<template>
  <div id="app" :class="preQuizClass">
    <transition-group name="fade">

      <div class="wrap" v-show="startedQuiz === false" key="intro" >
        <div class="intro">
          
          <div class="intro-inner" v-show="preQuizClass == 'begin'" key="beginPre">
            <h1>States of Matter and Phase Changes</h1>
            <p>Complete the quiz to practice connecting states of matter and phase changes with particle diagrams.</p>
            <button class="btn" v-on:click="preQuizClass = 'matter'">Begin Quiz</button>
          </div>

          <div class="intro-inner" v-show="preQuizClass == 'matter'" key="matterPre">
            <h2>States of Matter and Phase Changes</h2>
            <img src="./assets/matter.png" alt="">
            <button class="btn" v-on:click="preQuizClass = 'particles'">Next</button>
          </div>

          <div class="intro-inner" v-show="preQuizClass == 'particles'" key="particlesPre">
            <h2>States of Matter and Phase Changes</h2>
            <img src="./assets/particles.png" alt="">
            <button class="btn" v-on:click="beginQuiz">Begin Quiz</button>
          </div>

        </div>
      </div>

      <quiz v-bind:questionAs="questionAs" v-bind:questionBs="questionBs" v-on:restartQuiz="resetQuiz" v-show="startedQuiz === true" key="quizComponent"></quiz>

    </transition-group>
  </div>
</template>

<script>
import Quiz from './components/Quiz.vue'

export default {
  name: 'app',
  components: {
    Quiz
  },
  methods: {
    beginQuiz: function () {
      this.startedQuiz = true;
      this.preQuizClass = '';
    },
    resetQuiz: function () {
      this.startedQuiz = false;
      this.preQuizClass = 'begin';
    }
  },
  data: function () {
    return {
      startedQuiz: false,
      preQuizClass: 'begin',
      questionAs: [
        {
          type: 'A',
          sample: 'Water',
          symbol: 'H<sub>2</sub>0',
          freezmelt: 0,
          boil: 100,
          current: 150,
          answer: 'A'
        },
        {
          type: 'A',
          sample: 'Water',
          symbol: 'H<sub>2</sub>0',
          freezmelt: 0,
          boil: 100,
          current: 65,
          answer: 'B'
        },
        {
          type: 'A',
          sample: 'Ethanol',
          symbol: 'C<sub>2</sub>H<sub>5</sub>OH',
          freezmelt: -114,
          boil: 78.4,
          current: 0,
          answer: 'B'
        },
        {
          type: 'A',
          sample: 'Ethanol',
          symbol: 'C<sub>2</sub>H<sub>5</sub>OH',
          freezmelt: -114,
          boil: 78.4,
          current: -150,
          answer: 'C'
        },
        {
          type: 'A',
          sample: 'Mercury',
          symbol: 'Hg',
          freezmelt: -38,
          boil: 356,
          current: 175,
          answer: 'B'
        },
        {
          type: 'A',
          sample: 'Mercury',
          symbol: 'Hg',
          freezmelt: -38,
          boil: 356,
          current: 500,
          answer: 'A'
        },
        {
          type: 'A',
          sample: 'Propane',
          symbol: 'C<sub>3</sub>H<sub>8</sub>',
          freezmelt: -188,
          boil: -42,
          current: -15,
          answer: 'A'
        },
        {
          type: 'A',
          sample: 'Propane',
          symbol: 'C<sub>3</sub>H<sub>8</sub>',
          freezmelt: -188,
          boil: -42,
          current: -112,
          answer: 'B'
        },
        {
          type: 'A',
          sample: 'Methanol',
          symbol: 'CH<sub>3</sub>OH',
          freezmelt: -98,
          boil: 65,
          current: -105,
          answer: 'C'
        },
        {
          type: 'A',
          sample: 'Methanol',
          symbol: 'CH<sub>3</sub>OH',
          freezmelt: -98,
          boil: 65,
          current: 32,
          answer: 'B'
        },
        {
          type: 'A',
          sample: 'Oxygen',
          symbol: 'O<sub>2</sub>',
          freezmelt: -219,
          boil: -183,
          current: -55,
          answer: 'A'
        },
        {
          type: 'A',
          sample: 'Oxygen',
          symbol: 'O<sub>2</sub>',
          freezmelt: -219,
          boil: -183,
          current: 45,
          answer: 'A'
        },
        {
          type: 'A',
          sample: 'Gold',
          symbol: 'Au',
          freezmelt: 1064,
          boil: 2856,
          current: -175,
          answer: 'C'
        },
        {
          type: 'A',
          sample: 'Gold',
          symbol: 'Au',
          freezmelt: 1064,
          boil: 2856,
          current: 1225,
          answer: 'B'
        }
      ],
      questionBs: [
        {
          type: 'B',
          answer: 'Melting',
          video: '01_S to L.mp4'
        }, {
          type: 'B',
          answer: 'Freezing',
          video: '01_L to S.mp4'
        },
        {
          type: 'B',
          answer: 'Evaporation',
          video: '01_L to G.mp4'
        },
        {
          type: 'B',
          answer: 'Condensation',
          video: '01_G to L.mp4'
        },
        {
          type: 'B',
          answer: 'Deposition',
          video: '01_G to S.mp4'
        },
        {
          type: 'B',
          answer: 'Sublimation',
          video: '01_S to G.mp4'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles.scss";
.intro, {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  h1, p { 
    color: #fff; 
    margin: 0 auto 2.5rem;
    line-height: 1.5;
  }
  h1 {
    font: bold 32px $font-family;
    letter-spacing: 1.5px;
  }
  h2 {
    text-align: left;
    font: bold 18px $font-family;
    letter-spacing: 2px;
    color: #888;
    text-transform: uppercase;
  }
  p br { display: none; }
  .intro-inner { position: relative; }
  .btn { 
    background: transparent; 
    border: solid 1px $blue; 
    color: #fff; 
    text-transform: none; 
    &:hover { background: $blue; }
  }
}
@media screen and (min-width: 600px) {
  .intro p br { display: block; }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}
.fade-enter-active {
  transition-delay: 0.35s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.btn {
  border: none;
  background: $blue;
  color: #fff;
  padding: 10px 40px;
  text-transform: uppercase;
  font: bold 16px $font-family;
  letter-spacing: 2px;
  cursor: pointer;
}
p { 
  margin: 0 0 20px;
}
.begin {
  background: #000 url(./assets/bubbles.jpg) no-repeat center center / cover;
  p { max-width: 36rem; }
}
.matter, .particles {
  background: #1b1b1b;
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    margin: auto;
  }
  .btn {
    float: right;
    text-align: left;
    padding-left: 1rem;
    padding-right: 4rem;
    position: relative;
    &:after {
      position: absolute;
      top: 0;
      right: 0;
      content: '>';
      color: #fff;
      display: block;
      padding: 10px 5px 10px 0;
      font: bold 16px monospace;
    }
  }
}
</style>